// extracted by mini-css-extract-plugin
export default {"modulesList":"bpuDs","item":"nq7KG","product":"bSm59"};